const formElementVariants = {
    input: 'input',
    select: 'select'
} 
const defaultFormElementVariant= formElementVariants.input;

const formElementTypes = {
    text: 'text',
    number: 'number'
}

const defaultFormElementType = formElementTypes.text;

export {
    formElementVariants,
    defaultFormElementVariant,
    formElementTypes,
    defaultFormElementType
}